var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBingo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.078 9c.38 0 .72.035 1.02.104.298.068.552.171.76.311.212.14.373.315.483.527.11.21.165.458.165.743 0 .248-.054.481-.161.699a1.228 1.228 0 01-.537.532 1.327 1.327 0 01-.152.07c.112.028.212.066.3.115.242.13.416.304.52.52.105.214.157.439.157.673 0 .4-.088.734-.263 1.002-.172.268-.43.468-.773.602-.344.135-.77.202-1.278.202h-1.452a1 1 0 01-1-1V10a1 1 0 011-1h1.211zm-.768 5.085h.968c.203 0 .365-.031.487-.093a.595.595 0 00.266-.25.738.738 0 00.084-.352.956.956 0 00-.08-.408.546.546 0 00-.245-.263.912.912 0 00-.452-.097H11.31v1.463zm0-2.426h.718c.231 0 .417-.025.555-.075a.582.582 0 00.3-.23.686.686 0 00.098-.378.798.798 0 00-.098-.42.551.551 0 00-.309-.229 1.598 1.598 0 00-.537-.076h-.727v1.408z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5a7 7 0 110 14 7 7 0 010-14zm0 1.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17z",
    fill: "currentColor"
  })));
}
SvgBingo.displayName = 'Bingo';
export default SvgBingo;